import React, { useState, useEffect, useCallback, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  getAllActivities,
  updateActivity,
} from "../../api/Calendar/activityApi";
import {
  getCustomers,
  updateCustomer,
  getMyCustomers,
} from "../../api/Customer/customerApi";

/* import { createBooking } from "../api/bookingApi";  */
import { SidebarContext } from "../Sidebar/SidebarProvider";

import { makeStyles } from "@mui/styles";
import {
  Paper,
  Typography,
  Box,
  Drawer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  OutlinedInput,
  TextField,
  Tooltip,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import DescriptionIcon from "@mui/icons-material/Description";
import VideoCameraFrontOutlinedIcon from "@mui/icons-material/VideoCameraFrontOutlined";
import BusinessIcon from "@mui/icons-material/Business";
/* import CustomerForm from "../components/CustomerForm"; */

import CustomerForm from "../../components/Customer/CustomerForm";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

const DragAndDropCalendar = withDragAndDrop(Calendar);

const localizer = momentLocalizer(moment);

const CalendarPage = () => {
  const theme = useTheme();
  const { contentMargin } = useContext(SidebarContext);

  const useStyles = makeStyles(() => ({
    // Styles for various responsible persons
    responsableA: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#f8ff80",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableB: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#ff80cd",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableC: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#80faff94",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableD: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#8083ff9c",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableE: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#cecbbc",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableF: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#bcbfce",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableG: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#9be058",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableH: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#e058df",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableI: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#dfe058",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableJ: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#3174ad",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    responsableK: {
      padding: "8px",
      borderRadius: "6px",
      backgroundColor: "#63ad31ff",
      "&.MuiTypography-root": {
        fontWeight: "800",
        fontSize: "16px",
        marginTop: "8px",
        marginBottom: "2px",
      },
    },
    avatarA: {
      border: "2px solid rgb(0, 194, 163)",
      color: "rgb(0, 194, 163)",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarB: {
      border: "2px solid rgb(0, 194, 163)",
      color: "rgb(0, 194, 163)",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarC: {
      border: "2px solid #ffac7e",
      color: "#ffac7e",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarD: {
      border: "2px solid rgb(0, 194, 163)",
      color: "rgb(0, 194, 163)",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarE: {
      border: "2px solid #ffac7e",
      color: "#ffac7e",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarF: {
      border: "2px solid red",
      color: "red",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarG: {
      border: "2px solid rgb(0, 194, 163)",
      color: "rgb(0, 194, 163)",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarH: {
      border: "2px solid red",
      color: "red",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarI: {
      border: "2px solid red",
      color: "red",
      backgroundColor: "transparent",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      fontWeight: "800",
      marginTop: ".3em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    // Custom styles for calendar time labels
    timeGutter: {
      "& .rbc-timeslot-group": {
        height: "1.5em", // Adjust time slot height
      },
      "& .rbc-label": {
        fontSize: "12px", // Time label font size
        paddingLeft: "10px", // Align labels to the left
      },
    },
  }));
  const classes = useStyles();
  const [activities, setActivities] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentCustomerId, setCurrentCustomerId] = useState(null);

  // Filters
  const [selectedResponsables, setSelectedResponsables] = useState([]);
  const [selectedActivityTypes, setSelectedActivityTypes] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedABC, setSelectedABC] = useState([]);

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const isAdmin = decoded.isAdmin;

  // Options for filters
  const responsablesOptions = [
    "Irene",
    "Lydia",
    "Imma",
    "Sara",
    "Agustina",
    "Laura",
    "Chiara",
    "Alex",
    "Borja",
    "Miguel",
    "Mikael",
  ];
  const activityTypeOptions = [
    "Llamada",
    "Email",
    "Enviar presentación",
    "Video Call",
    "Visita",
  ];
  const abcOptions = ["AA", "AB", "AC", "BA", "BB", "BC", "CA", "CB", "CC"];

  // Fetch customers from API
  const fetchCustomers = useCallback(async () => {
    try {
      const data = await getMyCustomers(); // <-- solo los tuyos
      setCustomers(data);
    } catch (error) {
      console.error("Failed to fetch my customers:", error);
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  // Fetch activities from API
  const fetchActivities = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const isAdmin = decoded.isAdmin;

      const allActivities = await getAllActivities();

      let filtered;

      if (isAdmin) {
        filtered = allActivities; // 🔓 admin ve todo
      } else {
        const customerIds = customers.map((c) => c.id);
        filtered = allActivities.filter((activity) =>
          customerIds.includes(activity.customerId)
        );
      }

      setActivities(filtered);
      setFilteredActivities(filtered);
    } catch (error) {
      console.error("Failed to fetch activities:", error);
    }
  }, [customers]);

  useEffect(() => {
    if (customers.length > 0) {
      fetchActivities();
    }
  }, [customers, fetchActivities]);

  // Get color class based on responsible person
  const getCardColorClass = (responsableVentas) => {
    switch (responsableVentas) {
      case "Irene":
        return classes.responsableA;
      case "Lydia":
        return classes.responsableB;
      case "Imma":
        return classes.responsableC;

      case "Sara":
        return classes.responsableD;
      case "Agustina":
        return classes.responsableE;
      case "Laura":
        return classes.responsableF;

      case "Chiara":
        return classes.responsableG;

      case "Alex":
        return classes.responsableH;
      case "Borja":
        return classes.responsableI;
      case "Miguel":
        return classes.responsableJ;
      case "Mikael":
        return classes.responsableK;

      default:
        return "";
    }
  };

  // Filtering activities based on user input
  const handleFilterChange = () => {
    let filtered = activities;

    // Filter by search query for name or email
    if (searchQuery) {
      filtered = filtered.filter((activity) => {
        const customer = customers.find((c) => c.id === activity.customerId);
        return (
          customer &&
          ((customer.name ? customer.name.toLowerCase() : "").includes(
            searchQuery.toLowerCase()
          ) ||
            (customer.email ? customer.email.toLowerCase() : "").includes(
              searchQuery.toLowerCase()
            ))
        );
      });
    }

    // Filter by multi-select for responsables
    if (selectedResponsables.length > 0) {
      filtered = filtered.filter((activity) => {
        const customer = customers.find((c) => c.id === activity.customerId);
        return (
          customer && selectedResponsables.includes(customer.responsableVentas)
        );
      });
    }

    // Filter by activity types (multi-select)
    if (selectedActivityTypes.length > 0) {
      filtered = filtered.filter((activity) =>
        selectedActivityTypes.includes(activity.activityType)
      );
    }

    // Filter by ABC (multi-select)
    if (selectedABC.length > 0) {
      filtered = filtered.filter((activity) => {
        const customer = customers.find((c) => c.id === activity.customerId);
        return customer && selectedABC.includes(customer.abc);
      });
    }

    setFilteredActivities(filtered);
  };

  // Trigger filtering when filter values change
  useEffect(() => {
    handleFilterChange();
  }, [
    searchQuery,
    selectedResponsables,
    selectedActivityTypes,
    selectedABC,
    activities,
  ]);

  // Render icons based on activity type
  const renderActivityTypeIcon = (activityType) => {
    switch (activityType) {
      case "Llamada":
        return <PhoneIcon sx={{ color: "#dc3545" }} />;
      case "Email":
        return <EmailIcon sx={{ color: "#3174ad" }} />;
      case "Enviar presentación":
        return <DescriptionIcon sx={{ color: "#ffac7e" }} />;
      case "Visita":
        return <BusinessIcon sx={{ color: "#00c2a3" }} />;
      case "Video Call":
        return <VideoCameraFrontOutlinedIcon sx={{ color: "#c896ff" }} />;
      default:
        return null;
    }
  };

  // Custom event styles based on activity status
  const eventStyleGetter = (event) => {
    let backgroundColor = "#3174ad";

    switch (event.status) {
      case "Pending":
        backgroundColor = "#dc3545";
        break;
      case "On going":
        backgroundColor = "#3174ad";
        break;
      case "Video Call":
        backgroundColor = "#c896ff";
        break;
      case "Finished":
        backgroundColor = "#00c2a3";
        break;
      default:
        break;
    }

    const style = {
      backgroundColor: backgroundColor,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
    };

    return { style };
  };

  const getAvatarClass = (abc) => {
    switch (abc) {
      case "AA":
        return classes.avatarA;
      case "AB":
        return classes.avatarB;
      case "AC":
        return classes.avatarC;
      case "BA":
        return classes.avatarD;

      case "BB":
        return classes.avatarE;
      case "BC":
        return classes.avatarF;
      case "CA":
        return classes.avatarG;
      case "CB":
        return classes.avatarH;
      case "CC":
        return classes.avatarI;
      default:
        return "";
    }
  };

  // Open the drawer for editing a customer
  const handleOpenDrawer = (customerId) => {
    setCurrentCustomerId(customerId);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setCurrentCustomerId(null);
  };

  const handleFormSubmit = async (customer) => {
    if (currentCustomerId) {
      try {
        await updateCustomer(currentCustomerId, customer);
        fetchCustomers(); // Refresh customers after update
        handleCloseDrawer();
      } catch (error) {
        console.error("Failed to update customer:", error);
      }
    }
  };

  // Custom component for calendar events
  const ActivityEvent = ({ event }) => {
    const customer = customers.find((c) => c.id === event.customerId);
    const responsableVentas = customer?.responsableVentas || "Desconocido";

    return (
      <Tooltip
        title={customer?.observaciones || "Sin observaciones"}
        placement="right-start"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "16px",
              border: "1px solid #ddd",
            },
          },
        }}
      >
        <Paper
          sx={{
            p: 1,
            mb: 1,
            overflow: "auto",
            backgroundColor: theme.palette.background.paper,
          }}
          onClick={() => handleOpenDrawer(event.customerId)}
        >
          <Typography
            sx={{ fontWeight: "800", display: "flex", alignItems: "center" }}
          >
            {renderActivityTypeIcon(event.activityType)}
            <span style={{ marginLeft: ".5em" }}>
              {customer ? customer.name : "Cliente Desconocido"}
            </span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Typography className={getAvatarClass(customer?.abc || "")}>
              {customer?.abc || ""}
            </Typography>
            <Typography className={getCardColorClass(responsableVentas)}>
              {responsableVentas}
            </Typography>
          </Box>

          <Typography variant="body2">
            {event.subject || "Sin Asunto"}
          </Typography>
          <Typography variant="body2">
            {event.notes || "Sin notas adicionales"}
          </Typography>
          <Typography className={getCardColorClass(responsableVentas)}>
            {responsableVentas}
          </Typography>
          <Typography variant="body2">{event?.gMeetId || ""}</Typography>
        </Paper>
      </Tooltip>
    );
  };

  // Handle event resizing
  const handleEventResize = async ({ event, start, end }) => {
    try {
      await updateActivity(event.id, { ...event, activityDate: start });
      fetchActivities(); // Refresh activity list after update
    } catch (error) {
      console.error("Error updating activity:", error);
    }
  };

  // Handle event drop (drag & drop)
  const handleEventDrop = async ({ event, start, end }) => {
    try {
      await updateActivity(event.id, { ...event, activityDate: start });
      fetchActivities(); // Refresh activity list after update
    } catch (error) {
      console.error("Error updating activity:", error);
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Box
        sx={{
          p: 2,
          ...contentMargin,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Calendar
        </Typography>

        {/* Filters */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mb: 3,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <TextField
            label="Search by name or email"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          {/* Multiselect for Sales Responsibles */}
          <FormControl fullWidth>
            <InputLabel id="filter-responsable-label">
              Business Developer
            </InputLabel>
            <Select
              labelId="filter-responsable-label"
              multiple
              value={selectedResponsables}
              onChange={(e) => setSelectedResponsables(e.target.value)}
              input={<OutlinedInput label="Account Manager" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {responsablesOptions.map((responsable) => (
                <MenuItem key={responsable} value={responsable}>
                  <Checkbox
                    checked={selectedResponsables.includes(responsable)}
                  />
                  <ListItemText primary={responsable} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Multiselect for Activity Types */}
          <FormControl fullWidth>
            <InputLabel id="filter-activity-type-label">Activity</InputLabel>
            <Select
              labelId="filter-activity-type-label"
              multiple
              value={selectedActivityTypes}
              onChange={(e) => setSelectedActivityTypes(e.target.value)}
              input={<OutlinedInput label="Activity" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {activityTypeOptions.map((activityType) => (
                <MenuItem key={activityType} value={activityType}>
                  <Checkbox
                    checked={selectedActivityTypes.includes(activityType)}
                  />
                  <ListItemText primary={activityType} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Multiselect for ABC */}
          <FormControl fullWidth>
            <InputLabel id="filter-abc-label">ABC</InputLabel>
            <Select
              labelId="filter-abc-label"
              multiple
              value={selectedABC}
              onChange={(e) => setSelectedABC(e.target.value)}
              input={<OutlinedInput label="ABC" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {abcOptions.map((abc) => (
                <MenuItem key={abc} value={abc}>
                  <Checkbox checked={selectedABC.includes(abc)} />
                  <ListItemText primary={abc} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <DragAndDropCalendar
          localizer={localizer}
          events={filteredActivities.map((activity) => ({
            title:
              customers.find((c) => c.id === activity.customerId)?.name ||
              "Uknonw Client",
            start: moment(activity.activityDate).toDate(),
            end: moment(activity.activityDate).add(1, "hours").toDate(),
            ...activity,
          }))}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 1400 }}
          eventPropGetter={eventStyleGetter}
          components={{
            event: ActivityEvent,
          }}
          resizable
          selectable
          onEventResize={handleEventResize}
          onEventDrop={handleEventDrop}
          step={15} // Cada franja de 15 minutos
          timeslots={4} // Cuatro franjas por cada hora (15 minutos cada una)
          min={new Date(2023, 0, 1, 7, 0)} // Hora mínima visible (7 AM)
          max={new Date(2023, 0, 1, 22, 0)} // Hora máxima visible (10 PM)
          defaultView="week"
          views={["week", "day", "agenda"]}
          className={classes.timeGutter} // Añade la clase personalizada
        />

        <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
          <Box sx={{ width: { xs: 400, sm: 500, md: 1000, lg: 1830 }, p: 2 }}>
            <CustomerForm
              customerId={currentCustomerId}
              onSubmit={handleFormSubmit}
              onClose={handleCloseDrawer}
            />
          </Box>
        </Drawer>
      </Box>
    </DndProvider>
  );
};

export default CalendarPage;
